module.exports = __webpack_public_path__ + "fonts/font01-Italic.dc3adcd8.woff2";